module.exports = __webpack_public_path__ + "media/images/features/6/schedule-6-e4c51d4b188355d3d9978540d7ccdc6b.png";